    import { initializeApp } from "firebase/app";
    import { getAnalytics } from "firebase/analytics";

    const firebaseConfig = {
      apiKey: "AIzaSyDr29TkN74GCHNNgfjHPscZoPmyO8AxXc4",
      authDomain: "nhra-mehan-ebd8b.firebaseapp.com",
      projectId: "nhra-mehan-ebd8b",
      storageBucket: "nhra-mehan-ebd8b.firebasestorage.app",
      messagingSenderId: "2540326131",
      appId: "1:2540326131:web:40c21de4cb9ae8485ffb86",
      measurementId: "G-PLERBJN8S6"
    };

    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);

    export { analytics };